import OpeningDashboard from "./OpeningDashboard";

const OpeningDashboardPage = () => {
  return <OpeningDashboard />;
};

export default OpeningDashboardPage;
